import React, { useState } from 'react';
import { submitNetlifyForm } from '../../utils/netlifyForm';
import { useLang } from '../../i18n/LanguageContext';

// Field names must match the "payment-confirmation" form in public/__forms.html.
const FIELDS = [
  ['policy_holder_name', 'pfName', 'text'],
  ['policy_number', 'pfPolicy', 'text'],
  ['upi_transaction_id', 'pfTxn', 'text'],
  ['amount_paid', 'pfAmount', 'number'],
];

const PaymentConfirmForm = () => {
  const { t } = useLang();
  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState(null);

  const send = (e) => {
    e.preventDefault();
    setIsSending(true);
    setError(null);
    const form = e.target;
    submitNetlifyForm('payment-confirmation', form)
      .then(() => { setIsSending(false); setIsSent(true); form.reset(); },
        () => { setIsSending(false); setError(t('pfError')); });
  };

  if (isSent) {
    return (
      <div className="p-8 bg-emerald-50 border border-emerald-200 rounded-3xl text-center" role="status">
        <div className="text-4xl" aria-hidden="true">✅</div>
        <h3 className="mt-2 text-2xl font-extrabold text-emerald-800">{t('pfSentTitle')}</h3>
        <p className="text-emerald-700 mt-2">{t('pfSentText')}</p>
      </div>
    );
  }

  return (
    <form name="payment-confirmation" onSubmit={send} className="space-y-4">
      {/* Spam trap: people never see or fill this; Netlify drops any submission that has it filled */}
      <input type="text" name="bot-field" tabIndex="-1" autoComplete="off" className="hidden" aria-hidden="true" />
      {FIELDS.map(([name, label, type]) => (
        <label key={name} className="block text-sm font-semibold">
          {t(label)}
          <input type={type} name={name} required inputMode={type === 'number' ? 'decimal' : undefined}
            placeholder={name === 'upi_transaction_id' ? t('pfTxnPh') : undefined}
            className="mt-1.5 block w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-brand" />
        </label>
      ))}
      <button type="submit" disabled={isSending} className="w-full py-3.5 rounded-xl font-bold text-white bg-brand hover:bg-blue-800 disabled:bg-slate-400 transition">
        {isSending ? t('sending') : t('pfSubmit')}
      </button>
      {error && <p className="p-3 bg-rose-50 border border-rose-200 rounded-xl text-sm text-rose-700 text-center" role="alert">{error}</p>}
    </form>
  );
};

export default PaymentConfirmForm;
